import { LAZY_REFERENCE } from '../constants/type-stamps.const';
export function isLazyReference(x) {
    return x[LAZY_REFERENCE] === true;
}
//# sourceMappingURL=is-lazy-reference.util.js.map